import styled from 'styled-components';

import { Button, Grid, media } from '@minerva-analytics/pantheon';
import { MENU_ITEM_TEXT } from '../../theme';


export const ButtonGroupContainer = styled(Grid)`
  flex-direction: ${(props) => props.vertical ? `column` : `row`};
  ${(props) => (props.fixed ? `flex-wrap: nowrap;` : ``)};
  align-items: flex-start;
`;

export const ButtonComponent = styled(Button)`
  border-radius: 30px;
  padding: 10px 20px;
  ${MENU_ITEM_TEXT};
  cursor: pointer;
  display: inline-block;
  margin: 5px 0 5px 0;
  border: none;
  width: auto;
  text-align: left;
  transition: .2s;
  white-space: nowrap;
  ${media.phone`
    padding: 10px; 10px;
  `}
`;

export default {
  ButtonComponent,
  ButtonGroupContainer,
};
